import ProductCategoriesService from '@/services/productCategories';

export default {
	namespaced: true,
	state: {
	},

	getters: {
    
	},

	actions: {
		async getProductCategories({commit, state, getters, dispatch}){
			try{
				const response = await ProductCategoriesService.getProductCategories();
				return response
			}catch(e){
				console.log(e)
			}
		},		
		async createProductCategories({ commit, state, getters, dispatch }, payload) {
			let response;
			try {
				response = await ProductCategoriesService.createProductCategories({
					...payload
				});
			} catch (e) {
				console.log(e)
			}
			return response;
		},
		async updateProductCategories({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await ProductCategoriesService.updateProductCategories(payload.id, {
					...payload
				})
			} catch (e) {
				console.log(e);
			}
			return response;
		},
		async deleteProductCategories({ commit, state, getters, dispatch }, id) {
			let response;
			try {
				response = await ProductCategoriesService.deleteProductCategories(id);
			} catch (e) {
				console.log(e);
			}
			return response
		},
		async getCategoryProductById({ commit, state, getters, dispatch }, id) {
			let response
			try {
				response = await ProductCategoriesService.getCategoryProductById(id);
			} catch (e) {
				console.log(e);
			}
			return response
		},
		async uploadImage({commit, state, getters, dispatch}, payload) {
			try{
				const response = await ProductCategoriesService.uploadImage(payload);
				return response
			}catch(e){
				console.log(e)
			}
		},
		async removeImage({commit, state, getters, dispatch}, payload) {
			try{
				const response = await ProductCategoriesService.removeImage(payload);
				return response
			}catch(e){
				console.log(e)
			}
		},
	},

	mutations: {
		// SET_VALUE_FROM_API(state, payload) {
		// 	state.valueFromApi = payload;
		// }
	}
};
